export default "__VITE_ASSET__DDcxHtKC__"